import { render, staticRenderFns } from "./UpdateHolidayRemaining.vue?vue&type=template&id=71bde71c&scoped=true"
import script from "./UpdateHolidayRemaining.vue?vue&type=script&lang=js"
export * from "./UpdateHolidayRemaining.vue?vue&type=script&lang=js"
import style0 from "./UpdateHolidayRemaining.vue?vue&type=style&index=0&id=71bde71c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bde71c",
  null
  
)

export default component.exports